/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {isString} from 'lodash';
import {DiplomatFolder, IDiplomatFolder} from 'types/DiplomatFolder';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {enums} from 'types/enums';

export const VFSPathRequestParams = yup.object({
   vfspath: yup.string(),
});
export type IVFSPathRequestParams = yup.InferType<typeof VFSPathRequestParams>;

export const VFSNode = yup.object({
   absolutePath: yup.string(),
   vfspath: yup.string(),
   nodeId: yup.string(), // yup.number().integer(),
   type: yup.string().oneOf(enums.vfsType.keys),
   parentId: yup.string(), // yup.number().integer(),
   name: yup.string(),
   path: yup.string(),
   inheritPermissions: yup.boolean(),

   _originPath: yup.string(),
});
export type IVFSNode = yup.InferType<typeof VFSNode>;

const _VFSNodeDiplomat = DiplomatFolder.concat(VFSNode);
export const VFSNodeDiplomat =
   //  DiplomatFolder.concat(VFSNode)
   yup.mixed().transform(function (_val, origin) {
      // console.debug('cast vfs node', _val);
      if (isString(_val)) {
         const val = _VFSNodeDiplomat.cast({});
         val.id = _val;
         val.name = _val;
         val.path = _val;
         val.objectType = DiplomatObjectType.enum.FOLDER;
         val.childObjectType = DiplomatObjectType.enum.VFS;
         val.immutable = true;
         return val;
      } else if (!_val.id) {
         _val.objectType = DiplomatObjectType.enum.FOLDER;
         _val.childObjectType = DiplomatObjectType.enum.VFS;
         _val.immutable = true;
      }
      return _val;
   }) as yup.ObjectSchema<IVFSNode & IDiplomatFolder>;

export type IVFSNodeDiplomat = yup.InferType<typeof VFSNodeDiplomat>;

export const VFSNodeDiplomats = yup.array().of(VFSNodeDiplomat);
export type IVFSNodeDiplomats = yup.InferType<typeof VFSNodeDiplomats>;
